namespace TabAurous.OMS {
    export namespace KaratRateService {
        export const baseUrl = 'OMS/KaratRate';

        export declare function Create(request: Serenity.SaveRequest<KaratRateRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<KaratRateRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<KaratRateRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<KaratRateRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetRate(request: RateRequest, onSuccess?: (response: Serenity.ListResponse<KaratRateRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/KaratRate/Create",
            Update = "OMS/KaratRate/Update",
            Delete = "OMS/KaratRate/Delete",
            Retrieve = "OMS/KaratRate/Retrieve",
            List = "OMS/KaratRate/List",
            GetRate = "OMS/KaratRate/GetRate"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetRate'
        ].forEach(x => {
            (<any>KaratRateService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
